import { ApiController } from '@/services/ApiController';
import { ApiRoutes } from '@/enums/api/ApiRoutes';
import { AxiosResponse } from 'axios';

export default class DevCommandAPI {
  public static async run(command: string): Promise<AxiosResponse> {
    try {
      const response = await ApiController.post(ApiRoutes.runDevCommand, { command });
      return response as AxiosResponse;
    } catch (e) {
      throw e;
    }
  }
}